import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { InputRender } from '../../input.render';
export var InputControlPrefix = function (_a) {
    var prefix = _a.prefix;
    if (!prefix)
        return null;
    if (typeof prefix === 'string')
        return _jsx(_Fragment, { children: _jsx("div", { children: _jsx("span", { children: prefix }) }) });
    if (Array.isArray(prefix))
        return _jsx(_Fragment, { children: _jsx(InputRender, { content: prefix }) });
    if (typeof prefix === 'object')
        return _jsx(_Fragment, { children: _jsx(InputRender, { content: prefix }) });
};
